// src/redux/services/sadsayamember/sadsya.Services.js
import { baseApi } from "../baseApi";

export const SadasyaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // =============================================
    // GET PENDING SADASYA (status = 0)
    // =============================================
    getPendingSadasya: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/sadasya-pending`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Sadasya"],
    }),

    // =============================================
    // GET SUCCESS SADASYA (status = 1)
    // =============================================
    getSuccessSadasya: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/sadasya-success`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Sadasya"],
    }),

    // =============================================
    // GET REJECTED SADASYA (status = 2)
    // =============================================
    getRejectedSadasya: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/sadasya-rejected`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Sadasya"],
    }),

    // =============================================
    // GET ALL SADASYA WITH PAGINATION & FILTERS
    // =============================================
    getAllSadasya: builder.query({
      query: ({ 
        page = 1, 
        limit = 10, 
        search = "", 
        status = "",
        waad_id = "",
        role = ""
      } = {}) => {
        let url = `/sadasya-list?page=${page}&limit=${limit}`;
        if (search) url += `&search=${search}`;
        if (status) url += `&status=${status}`;
        if (waad_id) url += `&waad_id=${waad_id}`;
        if (role) url += `&role=${role}`;
        return url;
      },
      providesTags: ["Sadasya"],
    }),

    // =============================================
    // GET SINGLE SADASYA BY ID
    // =============================================
    getSadasyaById: builder.query({
      query: (id) => ({
        url: `/sadasya-view/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Sadasya", id }],
    }),

    // =============================================
    // UPDATE SINGLE SADASYA STATUS
    // =============================================
    updateSadasyaStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/sadasya-status/${id}`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: ["Sadasya"],
    }),

    // =============================================
    // BULK STATUS UPDATE
    // =============================================
    bulkUpdateSadasyaStatus: builder.mutation({
      query: ({ userIds, status }) => ({
        url: `/sadasya-bulk-status`,
        method: "PUT",
        body: { userIds, status },
      }),
      invalidatesTags: ["Sadasya"],
    }),

  }),
});

// Export all hooks
export const {
  useGetPendingSadasyaQuery,
  useGetSuccessSadasyaQuery,
  useGetRejectedSadasyaQuery,
  useGetAllSadasyaQuery,
  useGetSadasyaByIdQuery,
  useUpdateSadasyaStatusMutation,
  useBulkUpdateSadasyaStatusMutation,
} = SadasyaApi;